import { render, staticRenderFns } from "./up_down.vue?vue&type=template&id=fec98bc8&scoped=true&"
import script from "./up_down.vue?vue&type=script&lang=js&"
export * from "./up_down.vue?vue&type=script&lang=js&"
import style0 from "./up_down.vue?vue&type=style&index=0&id=fec98bc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec98bc8",
  null
  
)

export default component.exports